// Generic HOC to hold other compponents if required.
const CdpAux = (props) => props.children;

export default CdpAux;